import { useParams } from "react-router-dom";
import { ProjectDetailsPage } from "./ProjectDetailsPage";

export function ProjectDetailsPageWrapper() {
  const { projectId } = useParams<{ projectId: string }>();

  if (!projectId) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="text-muted-foreground">Invalid project ID</div>
      </div>
    );
  }

  return <ProjectDetailsPage projectId={projectId} />;
}
